import { z } from "zod/v4";

export const GetSummaryMetricsResponseBodySchema = z.record(
  z.string(),
  z.object({
    visitors: z.string(),
  })
);

export type GetSummaryMetricsResponseBodyType = z.infer<
  typeof GetSummaryMetricsResponseBodySchema
>;
